/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import BuildingEnum from 'astro/enum/building';


export default class
{
  constructor (cass)
  {
    this.cass = cass;
  }


  getType ()
  {
    return this.cass.type;
  }


  getVariant ()
  {
    return this.cass.variant;
  }


  getName ()
  {
    return this.cass.name;
  }


  getResources ()
  {
    return this.cass.resources;
  }


  getRange ()
  {
    return this.cass.range;
  }


  getHealth ()
  {
    return this.cass.health;
  }


  getAttrition ()
  {
    return this.cass.attrition;
  }


  getCreateTime ()
  {
    return this.cass.create_time;
  }


  getDisbandTime ()
  {
    return this.cass.disband_time;
  }


  getSetupTime ()
  {
    return this.cass.setup_time;
  }


  getActiveTime ()
  {
    return this.cass.active_time;
  }


  getCooldownTime ()
  {
    return this.cass.cooldown_time;
  }


  isCenterEntity ()
  {
    return this.cass.center_entity;
  }


  isNormalEntity ()
  {
    return this.cass.normal_entity;
  }


  isPlatformEntity ()
  {
    return this.cass.platform_entity;
  }


};
